/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevance`
};

const da_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevans`
};

const de_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevanz`
};

const en_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevance`
};

const es_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevancia`
};

const fr_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Pertinence`
};

const hu_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevancia`
};

const it_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Rilevanza`
};

const nl_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevantie`
};

const pl_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Trafność`
};

const pt_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevância`
};

const sv_sort_relevance = /** @type {(inputs: {}) => string} */ () => {
	return `Relevans`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sort_relevance = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sort_relevance(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sort_relevance", locale)
	if (locale === "cs") return cs_sort_relevance(inputs)
	if (locale === "da") return da_sort_relevance(inputs)
	if (locale === "de") return de_sort_relevance(inputs)
	if (locale === "en") return en_sort_relevance(inputs)
	if (locale === "es") return es_sort_relevance(inputs)
	if (locale === "fr") return fr_sort_relevance(inputs)
	if (locale === "hu") return hu_sort_relevance(inputs)
	if (locale === "it") return it_sort_relevance(inputs)
	if (locale === "nl") return nl_sort_relevance(inputs)
	if (locale === "pl") return pl_sort_relevance(inputs)
	if (locale === "pt") return pt_sort_relevance(inputs)
	return sv_sort_relevance(inputs)
};
export { sort_relevance as "sort.relevance" }